import React, { Fragment, useEffect, useState } from 'react'
import moment from 'moment'
import {
  Row,
  Rate,
  Tooltip,
  Icon,
  Menu,
  Switch,
  Popconfirm,
  message,
  Dropdown
} from 'antd'
import { Course } from './styled'
import { pencil, trash } from '../../images'
import { withTranslation, Trans } from 'react-i18next'
import './styles.scss'
import { general } from '../../../../constants'
import { changePublishedMarketplace } from '../../../../services/api/courses'
import EditIcon from '../../../../assets/edit.svg'
import { TranslationOutlined } from '@ant-design/icons'
import langOptions from '../../../../components/CloningModal/langOptions'
import history from '../../../../history'

const getTitle = ({ title, type }, t) =>
  `${t('course:delete_warning')} "${title.substring(0, 50)}" ${type === 'Course'
    ? t('general:course')
    : type === 'Live Event'
      ? t('general:live_event')
      : type === 'Podcast'
        ? t('V3:podcast')
        : type === 'Skill'
          ? t('v4:skill')
          : type === 'Maze'
            ? t('v4:maze')
            : type === 'Channel'
              ? t('v4:channel')
              : type === 'Quest'
                ? t('v4:quest')
                : t('general:live_assessment')
  // : t('general:live_assessment').toUpperCase()
  }?`

const onCloneCourse = (e, data, props) => {
  const { onClone } = props
  // Ensure e is an event before calling stopPropagation
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation()
  }
  if (data.is_cloning) return
  onClone(data)
}
const clickTranslate = (e, data, props) => {
  const { onTranslate } = props
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation()
  }
  // if (data.is_cloning) return
  onTranslate(data)
}
const onDelete = (e, data, props) => {
  const { onRemove } = props
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation()
  }
  onRemove(data)
}

const directTo = data => {
  if (data.is_cloning) {
    return '#'
  }
  switch (data.type) {
    case 'Course':
      if (data.course_type === 'scorm') return `scorm/${data.id}`
      return `courses/${data.id}`
    case 'Live Event':
      return `events/${data.id}`
    case 'Podcast':
      return `podcast/${data.id}/play`
    case 'Live Assessment':
      return `assessments/${data.id}`
    case 'Maze':
      return `maze-detail/${data.id}`
    case 'Skill':
      return `skill-journey/${data.id}`
    case 'Channel':
      return `channel/${data.id}`
    case 'Quest':
      return `quest-create?hunt_id=${data.hunt_id}`

    default:
      break
  }
}
const checkStatus = (
  {
    is_finished: isFinished,
    type,
    event_type,
    start_date_time: startDataTime,
    duration = 0
  },
  t
) => {
  if (type === general.LIVE_EVENT || type === general.PODCAST) {
    if (!startDataTime) {
      return t('unPublishEvent')
    } else {
      const newTime = moment(startDataTime).format('LLLL')
      const diffMinutes = moment().diff(newTime, 'minutes')
      const newDuration = duration || 0 + 10
      const checkInterval = diffMinutes - newDuration

      if (checkInterval > 0) {
        if (event_type && event_type === 'discussion_room') {
          return t('v3:pastPodcast')
        } else {
          return t('pastEvent')
        }
      } else {
        if (isFinished) {
          if (event_type && event_type === 'discussion_room') {
            return t('v3:pastPodcast')
          }
          return t('pastEvent')
        } else {
          if (event_type && event_type === 'discussion_room') {
            return t('v3:upcomingPodcast')
          }
          return t('upcoming')
        }
      }
    }
  } else if (type === general.LIVE_ASSESSMENT) {
    if (!startDataTime) {
      return t('unPublishAssessment')
    } else {
      const newTime = moment(startDataTime).format('LLLL')
      const diffMinutes = moment().diff(newTime, 'minutes')
      const newDuration = duration || 0 + 10
      const checkInterval = diffMinutes - newDuration

      if (checkInterval > 0) {
        return t('pastAssessment')
      } else {
        if (isFinished) {
          return t('pastAssessment')
        } else {
          return t('upcomingAssessment')
        }
      }
    }
  } else if (type === 'Maze') {
    if (!startDataTime) {
      return t('unPublishMaze')
    } else {
      const newTime = moment(startDataTime).format('LLLL')
      const diffMinutes = moment().diff(newTime, 'minutes')
      const newDuration = duration || 0 + 10
      const checkInterval = diffMinutes - newDuration

      if (checkInterval > 0) {
        return t('pastMaze')
      } else {
        return t('upcomingMaze')
      }
    }
  } else if (type === 'Skill') {
    return t('v5:training_skill_journey')
  } else if (type === 'Channel') {
    return t('v5:video_channel')
  } else if (type === 'Quest') {
    return t('quest:quest_hunt')
  } else {
    if (isFinished) {
      return t('pastCourse')
    }
    return t('upcoming_course')
  }
}

const getTextByType = (type, action, t, data) => {
  switch (action) {
    case 'edit':
      return t('labels:edit_course')

    case 'delete':
      return t('labels:delete_course')

    case 'view':
      return t('labels:view_course')

    case 'clone':
      if (type === 'Course') {
        return t('labels:clone_course')
      } else {
        return t('Clone this maze')
      }
    case 'date':
      if (type === general.PODCAST) {
        return t('v3:date_podcast')
      } else if (type === general.LIVE_EVENT) {
        return t('labels:date_event')
      } else if (type === 'Maze') {
        return t('metamaze date')
      } else {
        return t('labels:date_assessment')
      }
    case 'translate':
      return t('v4:translateCourseTip')
    default:
      break
  }
}

const ECourse = ({ t, ...props }) => {
  const [isUpdating, setIsUpdating] = useState(false)
  const [isSwitchChecked, setSwitchChecked] = useState(true)

  const {
    data,
    onEdit,
    user: {
      info: { id: userId, is_super_admin }
    }
  } = props
  const dateFormat = 'D MMM YYYY, HH:mm'

  const { cover = {} } = data

  const src = cover && cover.resizes ? cover.resizes.medium : ""
  const date = moment(data.start_date_time).format(dateFormat)
  const tooltipEdit = getTextByType(data.type, 'edit', t)
  const tooltipDelete = getTextByType(data.type, 'delete', t)
  const tooltipView = getTextByType(data.type, 'view', t)
  const tooltipClone = getTextByType(data.type, 'clone', t)
  const tooltipTranslate = getTextByType(data.type, 'translate', t)
  let eventType
  if (
    data &&
    data.event_type === 'discussion_room' &&
    data.discussion_room_type !== 'stories'
  ) {
    eventType = 'PODCAST'
  } else if (
    data &&
    data.event_type === 'discussion_room' &&
    data.discussion_room_type === 'stories'
  ) {
    eventType = 'STORY'
  } else if (data && data.encoder === 'other_webrtc') {
    eventType = 'WEBINAR'
  } else if (data && data.encoder === 'conference') {
    eventType = 'CONFERENCE'
  } else if (data && data.encoder === 'peer2peer') {
    eventType = 'COACHING'
  } else if (data && data.type === 'Quest') {
    eventType = 'QUEST'
  } else {
    eventType =
      data && data.course_type === 'scorm'
        ? 'Scorm'
        : data && data.type && data.type.replace(' ', '_').toLowerCase()
  }

  const checkMarketplacePublishing = setting =>
    setting &&
    setting.publish_option &&
    (setting.publish_option === 'marketplace' ||
      setting.publish_option === 'organization_marketplace')

  const isPublished = data && data.marketplace && data.marketplace.is_published

  useEffect(() => {
    setSwitchChecked(isPublished)
  }, [isPublished])

  const onChangeMarketplacePublishing = () => {
    setIsUpdating(true)

    const dataType =
      data && data.type === 'Course'
        ? 'courses'
        : data.type === 'Channel'
          ? 'collections'
          : data.type === 'Skill'
            ? 'skills'
            : data.type === 'Maze'
              ? 'programme'
              : 'events'

    changePublishedMarketplace(
      { id: data && data.id, type: dataType },
      {
        is_published: !isSwitchChecked
      }
    )
      .then(res => {
        if (!isSwitchChecked) {
          message.success(`${data.type} is published to marketplace !`)
        }
        setSwitchChecked(val => !val)
        setIsUpdating(false)
      })
      .catch(err => {
        message.error(err.message)
        setIsUpdating(false)
      })
  }

  const isPublishedToMarketplace =
    data &&
    (data.type === 'Course' ||
      data.type === 'Skill' ||
      data.type === general.LIVE_EVENT ||
      data.type === 'Podcast' ||
      data.type === 'Channel' ||
      data.type === 'Maze') &&
    checkMarketplacePublishing(data.setting || data.privacy)

  const canTogglePublish =
    data &&
    (is_super_admin ||
      data.host_id === userId ||
      (data.host_ids && data.host_ids.indexOf(userId) !== -1) ||
      data.creator_id === userId ||
      data.user_id === userId)

  const isRestricted = data && data.is_restricted
  const menu = (
    <Menu className="secondary-image-upload">
      <Menu.Item key="1" onClick={() => onEdit(data)}>
        <Course.EveneLink>
          <Tooltip title={`${tooltipEdit} ${data.title}`}>
            <div className="workshop-edit-menu">
              <Course.IconEvents src={pencil} />
              &nbsp;{t('buttons:edit')}&nbsp;{data.type}
            </div>
          </Tooltip>
        </Course.EveneLink>
      </Menu.Item>
      {(data.type === 'Course' || data.type === 'Maze') && !isRestricted && (
        <Menu.Item
          key="2"
          onClick={e => {
            onCloneCourse(e, data, props)
          }}
        >
          <Course.EveneLink>
            <Tooltip title={`${tooltipClone}`}>
              <div className="workshop-edit-menu">
                <Icon type="copy" style={{ color: '#0068FF' }} />
                &nbsp;{t('buttons:clone')}&nbsp;{data.type}
              </div>
            </Tooltip>
          </Course.EveneLink>
        </Menu.Item>
      )}
      {data.type === 'Course' && !isRestricted && (
        <Menu.Item
          key="4"
          onClick={e => {
            clickTranslate(e, data, props)
          }}
        >
          <Course.EveneLink>
            <Tooltip title={`${tooltipTranslate}`}>
              <div className="workshop-edit-menu">
                <TranslationOutlined style={{ color: '#0068FF' }} />
                &nbsp;{t('v4:translateModalBtn')}&nbsp;{data.type}
              </div>
            </Tooltip>
          </Course.EveneLink>
        </Menu.Item>
      )}
      <Menu.Item key="3">
        <Course.Event
          title={getTitle(data, t)}
          okText={t('general:yes')}
          cancelText={t('general:no')}
          placement="left"
          icon={false}
          onConfirm={e => {
            onDelete(e, data, props)
          }}
        >
          <Tooltip title={`${tooltipDelete} ${data.title}`}>
            <div className="workshop-edit-menu">
              <Course.IconEvents src={trash} />
              &nbsp;{t('v4:delete')}&nbsp;{data.type}
            </div>
          </Tooltip>
        </Course.Event>
      </Menu.Item>
    </Menu>
  )
  const getLanguage = lang => {
    let language = 'English'
    try {
      language = langOptions.find(el => el.code === lang).name
    } catch (error) { }
    return language
  }
  const navigateTo = () => {
    if (data.is_cloning) {
      message.error(data.type + '  cloning in progress!')
      return
    }
    switch (data.type) {
      case 'Course':
        if (data.course_type === 'scorm') {
          history.push(`scorm/${data.id}`)
        } else {
          history.push(`courses/${data.id}`)
        }
        break
      case 'Live Event':
        history.push(`events/${data.id}`)
        break
      case 'Podcast':
        history.push(`podcast/${data.id}/play`)
        break
      case 'Live Assessment':
        history.push(`assessments/${data.id}`)
        break
      case 'Maze':
        history.push(`maze-detail/${data.id}`)
        break
      case 'Skill':
        history.push(`skill-journey/${data.id}`)
        break
      case 'Channel':
        history.push(`channel/${data.id}`)
        break
      case 'Quest':
        if (!data.can_edit) {
          message.error(t('quest:no_permission_to_view_this_quest'))
          break
        }
        history.push(`quest-create?hunt_id=${data.hunt_id}`)
        break
      default:
        break
    }
  }

  return (
    <div className="workshop-course">
      <div
        className="workshop-course-cover"
        style={{ backgroundImage: `url(${src})` }}
      ></div>
      <div className="workshop-course-body">
        <div className="workshop-course-body-header">
          <div className="workshop-course-body-header-title">
            <div className="workshop-course-body-header-title-h1">
              {checkStatus(data, t)}
            </div>
            <div className="workshop-course-body-header-title-h2">
              <Tooltip title={`${tooltipView} ${data.title}`}>
                <div
                  className={'workshop-course-body-header-title-h2-titletext'}
                  style={data.type === 'Course' ? { width: '15rem' } : {}}
                >
                  <div
                    className="workshop-course-body-header-title-h2-titletext-text"
                    onClick={navigateTo}
                  >
                    {data.title}
                  </div>
                </div>
              </Tooltip>
              {data.type === 'Course' && data.course_type !== 'scorm' && (
                <div className="workshop-course-body-header-title-h2-lessons">
                  &nbsp; | &nbsp; {data.lessons_count || 0}{' '}
                  {(data.lessons_count || 0) > 1
                    ? t('general:lessons')
                    : t('general:lesson')}
                </div>
              )}
            </div>
          </div>
          {(data.type === 'Course' || data.type === 'Quest') && (
            <div
              className="workshop-course-body-header-type"
              style={{
                width: `${(data.type === 'Course' || data.type === 'Quest') ? 'calc(100% - 13rem)' : '100%'
                  }`
              }}
            >
              <div className="workshop-course-body-header-type-tags">
                <span> {t(`general:${eventType}`)}</span>
              </div>
              {data.is_ai_generated && (
                <div className="workshop-course-body-header-type-ai">
                  <span>AI</span>
                </div>
              )}
            </div>
          )}
          <div className="workshop-course-body-header-action">
            <Dropdown
              overlay={menu}
              trigger={['click']}
              placement="bottomRight"
            >
              <span className="image-edit" size="large">
                <img src={EditIcon} alt="" />
              </span>
            </Dropdown>
          </div>
        </div>

        <div className="workshop-course-body-tags">
          {data.avg_rating && (
            <div className="workshop-course-body-rate">
              {data.avg_rating.toFixed(2)}
              <Rate
                value={data.avg_rating}
                style={{ fontSize: 16, color: '#5B6EE2' }}
              />
            </div>
          )}
          {data.type === 'Course' && data.is_translated && (
            <>
              <div className="workshop-course-body-tags-translation">
                <span>{t('v4:isTranslated')}</span>
              </div>
              <div className="workshop-course-body-tags-language">
                <span>{getLanguage(data.lang)}</span>
              </div>
            </>
          )}
        </div>

        {data.type !== 'Course' && data.type !== 'Quest' && (
          <div className="workshop-course-body-header-type">
            <div className="workshop-course-body-header-type-tags">
              <span> {t(`general:${eventType}`)}</span>
            </div>
            {data.type === 'Maze' && !data.is_published && (
              <div className="workshop-course-body-tags-draft">
                <span>{t('v5:draft')}</span>
              </div>
            )}
            {data.type === general.LIVE_EVENT && data.start_date_time && (
              <Course.DateLive>
                <Trans i18nKey="">
                  <Course.DateLabel>
                    {getTextByType(data.type, 'date', t, data)} :{' '}
                    <Course.DateStrong>{{ date }}</Course.DateStrong>
                  </Course.DateLabel>
                </Trans>
              </Course.DateLive>
            )}
          </div>
        )}

        {data.type === 'Quest' && (
          <>
            <div className="workshop-quest-stats">
              <div className="workshop-quest-stat-item">
                <span className="workshop-quest-stat-label">{t('labels:points') || 'POINTS'}</span>
                <span className="workshop-quest-stat-value">{data.total_points || 0}</span>
              </div>
              <div className="workshop-quest-stat-item">
                <span className="workshop-quest-stat-label">{t('labels:age') || 'AGE'}</span>
                <span className="workshop-quest-stat-value">{data.age_group || '-'}</span>
              </div>
              <div className="workshop-quest-stat-item">
                <span className="workshop-quest-stat-label">{t('labels:steps') || 'STEPS'}</span>
                <span className="workshop-quest-stat-value">{data.num_steps || 0}</span>
              </div>
              <div className="workshop-quest-stat-item workshop-quest-stat-item--review">
                <span className="workshop-quest-stat-label">{t('labels:review') || 'REVIEW'}</span>
                <span className="workshop-quest-stat-value">{(data.reviews && data.reviews.length) || 0}</span>
              </div>
            </div>
            {data.objectives && (
              <div className="workshop-quest-objectives">
                <span className="workshop-quest-objectives-label">{t('labels:objectives') || 'OBJECTIVES'}</span>
                <p className="workshop-quest-objectives-text">{data.objectives}</p>
              </div>
            )}
          </>
        )}

        {isPublishedToMarketplace && canTogglePublish && (
          <div className="workshop-course-body-courseswitch">
            <Popconfirm
              title={`This will ${isSwitchChecked ? t('v5:unpublish') : t('v5:publish')
                } your ${data.type} from the marketplace. Are you sure?`}
              onConfirm={onChangeMarketplacePublishing}
              okText={t('v4:yes')}
              cancelText={t('v4:no')}
              icon={false}
            >
              <Switch loading={isUpdating} checked={isSwitchChecked} />
            </Popconfirm>
            {isUpdating && isSwitchChecked
              ? t('v5:unpublishing')
              : isUpdating
                ? t('v5:publishing')
                : isSwitchChecked
                  ? t('v5:unpublish_from_marketplace')
                  : t('v5:unpublished')}
          </div>
        )}
        <div className="workshop-course-body-date">
          {t('created')} {moment(data.created_at).format(dateFormat)}
        </div>
      </div>
    </div>
  )
}

export default withTranslation('course')(ECourse)
